function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _regenerator() {
  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */var e,
    t,
    r = "function" == typeof Symbol ? Symbol : {},
    n = r.iterator || "@@iterator",
    o = r.toStringTag || "@@toStringTag";
  function i(r, n, o, i) {
    var c = n && n.prototype instanceof Generator ? n : Generator,
      u = Object.create(c.prototype);
    return _regeneratorDefine2(u, "_invoke", function (r, n, o) {
      var i,
        c,
        u,
        f = 0,
        p = o || [],
        y = !1,
        G = {
          p: 0,
          n: 0,
          v: e,
          a: d,
          f: d.bind(e, 4),
          d: function d(t, r) {
            return i = t, c = 0, u = e, G.n = r, a;
          }
        };
      function d(r, n) {
        for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) {
          var o,
            i = p[t],
            d = G.p,
            l = i[2];
          r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0));
        }
        if (o || r > 1) return a;
        throw y = !0, n;
      }
      return function (o, p, l) {
        if (f > 1) throw TypeError("Generator is already running");
        for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) {
          i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);
          try {
            if (f = 2, i) {
              if (c || (o = "next"), t = i[o]) {
                if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object");
                if (!t.done) return t;
                u = t.value, c < 2 && (c = 0);
              } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);
              i = e;
            } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break;
          } catch (t) {
            i = e, c = 1, u = t;
          } finally {
            f = 1;
          }
        }
        return {
          value: t,
          done: y
        };
      };
    }(r, o, i), !0), u;
  }
  var a = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  t = Object.getPrototypeOf;
  var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () {
      return this;
    }), t),
    u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c);
  function f(e) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e;
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () {
    return this;
  }), _regeneratorDefine2(u, "toString", function () {
    return "[object Generator]";
  }), (_regenerator = function _regenerator() {
    return {
      w: i,
      m: f
    };
  })();
}
function _regeneratorDefine2(e, r, n, t) {
  var i = Object.defineProperty;
  try {
    i({}, "", {});
  } catch (e) {
    i = 0;
  }
  _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) {
    function o(r, n) {
      _regeneratorDefine2(e, r, function (e) {
        return this._invoke(r, n, e);
      });
    }
    r ? i ? i(e, r, {
      value: n,
      enumerable: !t,
      configurable: !t,
      writable: !t
    }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2));
  }, _regeneratorDefine2(e, r, n, t);
}
function asyncGeneratorStep(n, t, e, r, o, a, c) {
  try {
    var i = n[a](c),
      u = i.value;
  } catch (n) {
    return void e(n);
  }
  i.done ? t(u) : Promise.resolve(u).then(r, o);
}
function _asyncToGenerator(n) {
  return function () {
    var t = this,
      e = arguments;
    return new Promise(function (r, o) {
      var a = n.apply(t, e);
      function _next(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "next", n);
      }
      function _throw(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "throw", n);
      }
      _next(void 0);
    });
  };
}
function _createForOfIteratorHelper(r, e) {
  var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (!t) {
    if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
      t && (r = t);
      var _n = 0,
        F = function F() {};
      return {
        s: F,
        n: function n() {
          return _n >= r.length ? {
            done: !0
          } : {
            done: !1,
            value: r[_n++]
          };
        },
        e: function e(r) {
          throw r;
        },
        f: F
      };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }
  var o,
    a = !0,
    u = !1;
  return {
    s: function s() {
      t = t.call(r);
    },
    n: function n() {
      var r = t.next();
      return a = r.done, r;
    },
    e: function e(r) {
      u = !0, o = r;
    },
    f: function f() {
      try {
        a || null == t["return"] || t["return"]();
      } finally {
        if (u) throw o;
      }
    }
  };
}
function _unsupportedIterableToArray(r, a) {
  if (r) {
    if ("string" == typeof r) return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
  }
}
function _arrayLikeToArray(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
  return n;
}
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
var Tweet = require('../tweet');
var ModerateTemplate = require('./moderate.template');
var Moderate = /*#__PURE__*/function () {
  function Moderate(app, mod) {
    _classCallCheck(this, Moderate);
    this.app = app;
    this.mod = mod;
    this.txs = [];
    this.tweets = [];
    this.container = '';
  }
  return _createClass(Moderate, [{
    key: "setTransactions",
    value: function setTransactions() {
      var txs = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      this.txs = Array.isArray(txs) ? txs.filter(Boolean) : [];
      this.tweets = [];
      var _iterator = _createForOfIteratorHelper(this.txs),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var tx = _step.value;
          var tweet = new Tweet(this.app, this.mod, tx);
          if (tweet.signature) {
            // Review items stay private to this component — never enter the timeline.
            // Clear display mask so moderators can read the reported content.
            tweet.flagged = 0;
            this.tweets.push(tweet);
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    }
  }, {
    key: "count",
    value: function count() {
      return this.tweets.length;
    }
  }, {
    key: "render",
    value: function render() {
      var container = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      if (container) {
        this.container = container;
      }
      if (!this.container || !this.app.BROWSER) {
        return;
      }
      var panel = document.querySelector(this.container);
      if (!panel) {
        return;
      }
      panel.querySelectorAll(':scope > .moderate').forEach(function (node) {
        return node.remove();
      });
      var html = ModerateTemplate(this);
      if (!html) {
        return;
      }
      panel.insertAdjacentHTML('afterbegin', html);
      this.attachEvents();
    }

    /**
     * Keep the review block above notification rows after prepends.
     */
  }, {
    key: "ensureTop",
    value: function ensureTop() {
      if (!this.container || !this.app.BROWSER) {
        return;
      }
      var panel = document.querySelector(this.container);
      if (!panel) {
        return;
      }
      var moderate = panel.querySelector(':scope > .moderate');
      if (moderate && panel.firstElementChild !== moderate) {
        panel.prepend(moderate);
      }
    }
  }, {
    key: "attachEvents",
    value: function attachEvents() {
      var _this = this;
      if (!this.container) {
        return;
      }
      var root = document.querySelector("".concat(this.container, " > .moderate"));
      if (!root) {
        return;
      }
      root.querySelectorAll('[data-action]').forEach(function (button) {
        button.onclick = function (e) {
          e.preventDefault();
          e.stopPropagation();
          var action = button.getAttribute('data-action');
          var signature = button.getAttribute('data-id');
          var tweet = _this.tweets.find(function (item) {
            return item.signature === signature;
          });
          if (!tweet) {
            return;
          }
          if (action === 'approve') {
            _this.handleApprove(tweet);
            return;
          }
          if (action === 'delete') {
            _this.handleDelete(tweet);
            return;
          }
          if (action === 'ban') {
            _this.handleBan(tweet);
          }
        };
      });
    }
  }, {
    key: "handleApprove",
    value: function () {
      var _handleApprove = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(tweet) {
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              _context.n = 1;
              return this.submitReview(tweet, 'approve');
            case 1:
              return _context.a(2);
          }
        }, _callee, this);
      }));
      function handleApprove(_x) {
        return _handleApprove.apply(this, arguments);
      }
      return handleApprove;
    }()
  }, {
    key: "handleDelete",
    value: function () {
      var _handleDelete = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(tweet) {
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              _context2.n = 1;
              return this.submitReview(tweet, 'delete');
            case 1:
              return _context2.a(2);
          }
        }, _callee2, this);
      }));
      function handleDelete(_x2) {
        return _handleDelete.apply(this, arguments);
      }
      return handleDelete;
    }()
  }, {
    key: "handleBan",
    value: function () {
      var _handleBan = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3(tweet) {
        var publicKey;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.n) {
            case 0:
              publicKey = (tweet === null || tweet === void 0 ? void 0 : tweet.publicKey) || '';
              _context3.n = 1;
              return this.submitReview(tweet, 'delete');
            case 1:
              if (publicKey && publicKey !== this.mod.publicKey) {
                this.app.connection.emit('saito-blacklist', {
                  publicKey: publicKey
                });
              }
            case 2:
              return _context3.a(2);
          }
        }, _callee3, this);
      }));
      function handleBan(_x3) {
        return _handleBan.apply(this, arguments);
      }
      return handleBan;
    }()
  }, {
    key: "submitReview",
    value: function () {
      var _submitReview = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4(tweet, decision) {
        var tx, _t;
        return _regenerator().w(function (_context4) {
          while (1) switch (_context4.p = _context4.n) {
            case 0:
              if (!(!(tweet !== null && tweet !== void 0 && tweet.signature) || decision !== 'approve' && decision !== 'delete')) {
                _context4.n = 1;
                break;
              }
              return _context4.a(2);
            case 1:
              _context4.p = 1;
              _context4.n = 2;
              return this.mod.createReviewTweetTransaction({
                signature: tweet.signature,
                decision: decision
              });
            case 2:
              tx = _context4.v;
              _context4.n = 3;
              return this.app.network.sendRequestAsTransaction('review tweet', tx.msg.data);
            case 3:
              _context4.n = 4;
              return this.mod.receiveReviewTweetTransaction(tx);
            case 4:
              _context4.n = 6;
              break;
            case 5:
              _context4.p = 5;
              _t = _context4.v;
              console.error('RedSquare review failed:', _t);
              siteMessage('Unable to submit review', 2500);
            case 6:
              return _context4.a(2);
          }
        }, _callee4, this, [[1, 5]]);
      }));
      function submitReview(_x4, _x5) {
        return _submitReview.apply(this, arguments);
      }
      return submitReview;
    }()
  }, {
    key: "removeTweet",
    value: function removeTweet(signature) {
      var _this$mod$updateNotif, _this$mod;
      var before = this.tweets.length;
      this.tweets = this.tweets.filter(function (tweet) {
        return tweet.signature !== signature;
      });
      this.txs = this.txs.filter(function (tx) {
        return String((tx === null || tx === void 0 ? void 0 : tx.signature) || '') !== String(signature);
      });
      if (this.tweets.length === before) {
        return;
      }
      this.render();
      (_this$mod$updateNotif = (_this$mod = this.mod).updateNotificationBadge) === null || _this$mod$updateNotif === void 0 || _this$mod$updateNotif.call(_this$mod);
    }
  }]);
}();
module.exports = Moderate;